import React from 'react';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CallMadeIcon from '@material-ui/icons/CallMade';

import { formatCoordinates, googleMapsUrl } from 'helpers/formatCoordinates';
import { styles } from './styles';

const useStyles = makeStyles(styles);

const GeoCell = ({ coordinates }) => {
  const classes = useStyles();

  if (!coordinates) return <span className={classes.empty}>&mdash;</span>;

  return (
    <span className={classes.root}>
      <span className={classes.coordinates}>{formatCoordinates(coordinates)}</span>
      <IconButton
        size="small"
        className={classes.link}
        aria-label="Open in Google Maps"
        href={googleMapsUrl(coordinates)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <CallMadeIcon fontSize="inherit" />
      </IconButton>
    </span>
  );
};

export default GeoCell;
